module.exports = __webpack_public_path__ + "img/397438607807bedc4771defb9bfc9ff1.9bff2118.png";